import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import changestateaction from "../../context/action/service/changestateaction";
import Editservicemodal from "./editservicemodal";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";

const Servicelist = () => {
    const { initState, recaller, setrecaller, clear, initDispatch } =
        useContext(GlobalContext);

    const [service_id, setservice_id] = useState();
    const [service_name, setservice_name] = useState();
    const [service_price, setservice_price] = useState();
    const [show, setshow] = useState(false);

    return (
        <div className="w-full">
            <Editservicemodal
                show={show}
                setshow={setshow}
                service_id={service_id}
                service_name={service_name}
                setservice_name={setservice_name}
                service_price={service_price}
                setservice_price={setservice_price}
            />

            {/* Expense Type List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">لیستی جۆری خەرجی</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناو
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                نرخ
                            </th>
                            {/* <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                دۆخ
                            </th> */}
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                گۆڕانکاری
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.service.map((lis) => (
                            <tr
                                key={lis.service_id}
                                className="hover:bg-slate-50 transition-colors duration-100"
                            >
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.service_name}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(money_rounding(lis.service_price))}
                                </td>
                                {/* <td
                                    className="px-6 py-4 text-sm font-medium text-slate-800 text-right"
                                    onClick={() => {
                                        changestateaction(lis.service_id)(recaller)(setrecaller)(initDispatch)(clear);
                                    }}
                                >
                                    <button
                                        className={
                                            lis.service_state == "active"
                                            ? "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border border-emerald-200 transition-colors cursor-pointer"
                                            : "inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-red-50 text-red-700 hover:bg-red-100 border border-red-200 transition-colors cursor-pointer"
                                        }
                                    >
                                        {lis.service_state}
                                    </button>
                                </td> */}
                                <td
                                    className="px-3 sm:px-5 py-3 sm:py-4 border-b border-gray-200 text-xs sm:text-sm cursor-pointer"
                                >
                                    <button
                                        className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-200 transition-colors cursor-pointer"
                                        onClick={() => {
                                            setservice_id(lis.service_id);
                                            setservice_name(lis.service_name);
                                            setservice_price(lis.service_price);
                                            setshow(true);
                                        }}
                                    >
                                        گۆڕانکاری
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Servicelist;